import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import hash from 'object-hash';
import { AxiosError } from 'axios';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { JobApplication } from '../../../providers/api/dtos';
import { getJobApplications, JobApplicationFilters } from '../../../providers/api/job-application/jobApplicationProvider';

export const JOB_APPLICATIONS_RID = 'v2/job-applications';

export function useJobApplications(filters: JobApplicationFilters | null, pagination?: PaginationParams, options?: SWRConfiguration<PaginatedResult<JobApplication>, AxiosError>): SWRResponse<PaginatedResult<JobApplication>, AxiosError> {
  return useSWR(filters && [JOB_APPLICATIONS_RID, hash({ ...filters, ...pagination })], () => getJobApplications(filters!, pagination), options);
}
